import { z } from "zod";
const identifier = (_brand) => z.string().trim().min(1).max(128).brand();
export const AccountIdSchema = identifier("AccountId");
export const AmoLeadIdSchema = identifier("AmoLeadId");
export const AmoContactIdSchema = identifier("AmoContactId");
export const AmoUserIdSchema = identifier("AmoUserId");
export const InstructorIdSchema = identifier("InstructorId");
export const VenueIdSchema = identifier("VenueId");
export const CourseTemplateIdSchema = identifier("CourseTemplateId");
export const CourseTemplateVersionIdSchema = identifier("CourseTemplateVersionId");
export const EnrollmentIdSchema = identifier("EnrollmentId");
export const LessonIdSchema = identifier("LessonId");
export const PaymentReportIdSchema = identifier("PaymentReportId");
export const AuditEventIdSchema = identifier("AuditEventId");
export const OutboxItemIdSchema = identifier("OutboxItemId");
